<h1>{{ "SUCCESS.GREETING" | translate }}</h1>
<h2>{{ user }}</h2>

<p class="mb30">
  {{ "SUCCESS.MSG" | translate }} {{ operation | translate }}.
  {{ "SUCCESS.QUESTION" | translate }}
</p>

<div
  class="container"
  fxLayout="row"
  fxLayout.xs="column"
  fxLayoutWrap
  fxLayoutGap="0.5%"
  fxLayoutAlign="center"
>
  <div fxFlex="70%">
    <mat-list>
      <mat-list-item
        (click)="
          trackId
            ? redirectAutoLogin()
            : commonFunc.getRedirectedByRequestId()
        "
      >
        <mat-icon matListIcon [inline]="true" color="primary"
          >leaderboard</mat-icon
        >
        <h3 matLine>{{ "TO_PORTAL" | translate }}</h3>
      </mat-list-item>
    </mat-list>
  </div>
</div>
